import React from "react";

const Response = () => {
  return (
    <div
      className="full_container flex response"
      role="alert"
      aria-busy="true"
      aria-live="assertive"
    />
  );
};

export default Response;
